import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { JwtModule } from '@auth0/angular-jwt';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GetTokenNow } from '@reusable/services/globals';
import { S3Uploader } from '@reusable/services/helpers/uploader.service';
import { SharedModule } from '@reusable/shared/shared.module';
import { FIREBASE_CONFIG } from '@src/firebase.config';
import { CustomFiltersService } from '@team/services/common/custom-filters.service';
import { DateValueAccessorModule } from 'angular-date-value-accessor';
import { initializeApp } from 'firebase/app';
import { CookieService } from 'ngx-cookie-service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { carServicesProvidersRoutes } from './car-services-providers.routes';
import { ProvidersDashboardComponent } from './common/providers-dashboard/providers-dashboard.component';
import { ProvidersMenuComponent } from './common/providers-menu/providers-menu.component';
import { AnonymousGuardService } from './services/auth/AnonymousGuard.service';
import { AuthGuardService } from './services/auth/auth-guard.service';
import { CarProvidersAuthService } from './services/auth/auth.service';

initializeApp(FIREBASE_CONFIG);

// Token tokenGetter
export const tokenGetter = () => localStorage.getItem('accessToken');
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/public/resources/i18n/', '-team.json');
}
@NgModule({ declarations: [
  AppComponent,
  ProvidersMenuComponent,
  ProvidersDashboardComponent
],
exports: [SharedModule, TranslateModule],
bootstrap: [AppComponent], imports: [TranslateModule.forRoot({
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient]
  }
}),
SharedModule,
RouterModule.forRoot(carServicesProvidersRoutes, {}),
BrowserModule,
BrowserAnimationsModule,
FormsModule,
ReactiveFormsModule,
DateValueAccessorModule,
RouterModule,
CommonModule,
NgSelectModule,
InfiniteScrollModule,
JwtModule.forRoot({
  config: {
    tokenGetter,
    allowedDomains: [],
    disallowedRoutes: []
  }
}),
ToastrModule.forRoot({
  maxOpened: 1,
  autoDismiss: true,
  preventDuplicates: true,
  positionClass: 'toast-top-left'
})], providers: [
  CarProvidersAuthService,
  AnonymousGuardService,
  AuthGuardService,
  GetTokenNow,
  S3Uploader,
  CookieService,
  CustomFiltersService,
  provideHttpClient(withInterceptorsFromDi())
] })
export class CarServicesProvidersModule { }